import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React from "react"
import { injectIntl } from "react-intl"
import { Redirect } from "react-router-dom"
import SideBar from "../../common/layout/sidebar.component"
import GenericListing from "../../common/listing/generic-listing/GenericListing"
import { ObjectType } from "../../state/listing/generic-listing"

const QuoteListing = () => {
    SideBar.activateMenu("quote")

    if (AppContext.getAccount().attributes.onBoardingStatus === "pending") {
        return <Redirect to={{ pathname: "/" }} />
    }

    return (
        <GenericListing
            objectType={ObjectType.QUOTES}
            selectableRows
        />
    )
}

export default injectIntl(QuoteListing)


// WEBPACK FOOTER //
// ./src/quote/listing/List.tsx